import React from "react";
import { createSearchParams, Navigate, NavigateFunction } from "react-router-dom";
import { Dashboard, Kpi, FeedCurves, Components, FeedCurve, Silos, SilosSettings, Animals, AnimalsGroups, Animal, Reports, Report, Archive, Logbook, GlobalSettings, Devices } from "../../../Containers";
import { TabMenu } from "../../Menus";
import { GlobalMenu_Pages } from "../../pages";

export const Router = [
  { path:`/${GlobalMenu_Pages.dashboard}`, element:<TabMenu key={GlobalMenu_Pages.dashboard} main={GlobalMenu_Pages.dashboard} overrides={{ base_alternative: GlobalMenu_Pages.home }} contexts={[]}/>, 
    children:[
      {index: true, Component:Dashboard},
      {path: `*`, element: <Navigate to={`/${GlobalMenu_Pages.dashboard}`}/>}
    ]
  },  
  { path:`/${GlobalMenu_Pages.kpi}`, element:<TabMenu key={GlobalMenu_Pages.kpi} main={GlobalMenu_Pages.kpi} overrides={{ base_alternative: GlobalMenu_Pages.home }} contexts={[]}/>, 
    children:[
      {index: true, Component:Kpi}
    ]
  },  
  // { path:`/${GlobalMenu_Pages.feedCurves}`, element:<TabMenu key={GlobalMenu_Pages.feedCurves} main={GlobalMenu_Pages.feedCurves} overrides={{base_alternative:GlobalMenu_Pages.home}} contexts={[GlobalMenu_Pages.components,GlobalMenu_Pages.componentsAlternatives,GlobalMenu_Pages.mixtures,GlobalMenu_Pages.feedCurve]} />,
  { path:`/${GlobalMenu_Pages.feedCurves}`, element:<TabMenu key={GlobalMenu_Pages.feedCurves} main={GlobalMenu_Pages.feedCurves} overrides={{base_alternative:GlobalMenu_Pages.home}} contexts={[GlobalMenu_Pages.components,GlobalMenu_Pages.feedCurve]} />,
    children:[
      { index:true, path:`/${GlobalMenu_Pages.feedCurves}`, Component:FeedCurves},
      { path:`${GlobalMenu_Pages.components}`, Component:Components},
      // { path:`/${GlobalMenu_Pages.feedCurves}/${GlobalMenu_Pages.componentsAlternatives}`, element:<ComponentAlternatives/>},
      // { path:`/${GlobalMenu_Pages.feedCurves}/${GlobalMenu_Pages.mixtures}`, element:<Mixtures/>},
      { path:`${GlobalMenu_Pages.feedCurve}`, Component:FeedCurve},
      { path: `*`, element:<Navigate to={`/${GlobalMenu_Pages.feedCurves}`}/>}
    ]
  },
  { path:`/${GlobalMenu_Pages.silos}`, element:<TabMenu key={GlobalMenu_Pages.silos} main={GlobalMenu_Pages.silos} overrides={{base_alternative:GlobalMenu_Pages.home}} contexts={[GlobalMenu_Pages.silosSettings]} />,
    children:[
      { index:true, Component:Silos},
      { path:`${GlobalMenu_Pages.silosSettings}`, Component:SilosSettings},
      { path: `*`, element: <Navigate to = {`/${GlobalMenu_Pages.silos}`} /> }
    ]
  },
  { path:`/${GlobalMenu_Pages.animals}`, element:<TabMenu key={GlobalMenu_Pages.animals} main={GlobalMenu_Pages.animals} overrides={{base_alternative:GlobalMenu_Pages.home}} contexts={[GlobalMenu_Pages.animalsGroups, GlobalMenu_Pages.animal]} />,
    children:[
      { index:true, Component:Animals},
      { path:`${GlobalMenu_Pages.animalsGroups}`, Component:AnimalsGroups},
      { path:`${GlobalMenu_Pages.animal}`, Component:Animal},
      { path: `*`, element: <Navigate to={`/${GlobalMenu_Pages.animals}`} /> }
    ]
  },
  { path:`/${GlobalMenu_Pages.reports}`, element:<TabMenu key={GlobalMenu_Pages.reports} main={GlobalMenu_Pages.reports} overrides={{base_alternative:GlobalMenu_Pages.home}} contexts={[GlobalMenu_Pages.report, GlobalMenu_Pages.archive]} />,
    children:[
      { index:true, Component:Reports},
      { path:`${GlobalMenu_Pages.report}`, Component:Report},
      { path:`${GlobalMenu_Pages.archive}`, Component:Archive},
      { path: `*`, element: <Navigate to={`/${GlobalMenu_Pages.reports}`}/>}
    ]
  },
  { path:`/${GlobalMenu_Pages.logbook}`, element:<TabMenu key={GlobalMenu_Pages.logbook} main={GlobalMenu_Pages.logbook} overrides={{base_alternative:GlobalMenu_Pages.home}} contexts={[]} />,
    children:[
      {index: true, Component:Logbook},
      {path: '*', element: <Navigate to={`/${GlobalMenu_Pages.logbook}`} />}
    ]
  },
  { path:`/${GlobalMenu_Pages.globalSettings}`, element:<TabMenu key={GlobalMenu_Pages.globalSettings} main={GlobalMenu_Pages.globalSettings} overrides={{base_alternative:GlobalMenu_Pages.home}} contexts={[GlobalMenu_Pages.devices]} />,
    children:[
      { index: true, Component: GlobalSettings},
      { path:`${GlobalMenu_Pages.devices}`, Component:Devices},
      { path: `*`, element: <Navigate to={`/${GlobalMenu_Pages.globalSettings}`} />}
    ] 
  }
]
 

export const NavigationFunction = (Navigator: NavigateFunction, navigation_page:GlobalMenu_Pages, navigation_tab?:GlobalMenu_Pages, navArgs?:object, currentDomain?: string) => {
  const search = currentDomain ? createSearchParams({domain: currentDomain }).toString() : undefined;
  switch (navigation_page) { 
    case GlobalMenu_Pages.home:
      Navigator(GlobalMenu_Pages.home, {state:{global_index:0}})
    break
    case GlobalMenu_Pages.dashboard:
      Navigator({pathname:"../"+GlobalMenu_Pages.dashboard, search}, {state:{global_index:0, tab: 0, ...navArgs}})
    break
    case GlobalMenu_Pages.kpi:
      Navigator({pathname: `/${GlobalMenu_Pages.kpi}`, search}, {state:{global_index:1, tab: 0}})
    break
    case GlobalMenu_Pages.feedCurves:
      switch (navigation_tab) {
        case GlobalMenu_Pages.components:
          Navigator({pathname: `/${GlobalMenu_Pages.feedCurves}/${GlobalMenu_Pages.components}`, search}, {state:{global_index:2, tab:1}})
        break
        // case GlobalMenu_Pages.componentsAlternatives:
        //   Navigator(`/${GlobalMenu_Pages.feedCurves}/${GlobalMenu_Pages.componentsAlternatives}`, {state:{global_index:2, tab:2}})
        // break
        // case GlobalMenu_Pages.mixtures:
        //   Navigator(`/${GlobalMenu_Pages.feedCurves}/${GlobalMenu_Pages.mixtures}`, {state:{global_index:2, tab:2}})
        // break
        case GlobalMenu_Pages.feedCurve:
          Navigator({pathname: `/${GlobalMenu_Pages.feedCurves}/${GlobalMenu_Pages.feedCurve}`, search}, {state:{global_index:2, tab:2, params:{...navArgs}}})
        break
        default:
          Navigator({pathname: `/${GlobalMenu_Pages.feedCurves}`, search }, {state:{global_index:2, tab:0}})
      }
    break
    case GlobalMenu_Pages.silos:
      switch (navigation_tab) {
        case GlobalMenu_Pages.silosSettings:
            Navigator({pathname: `/${GlobalMenu_Pages.silos}/${GlobalMenu_Pages.silosSettings}`, search}, {state:{global_index:3, tab:1}})
          break
        default: Navigator({pathname: `/${GlobalMenu_Pages.silos}`, search}, {state:{global_index:3, tab:0}})
      }    
    break
    case GlobalMenu_Pages.animals:
      switch (navigation_tab) {
        case GlobalMenu_Pages.animalsGroups:
          Navigator({pathname: `/${GlobalMenu_Pages.animals}/${GlobalMenu_Pages.animalsGroups}`, search}, {state:{global_index:4, tab:1}})
        break
        case GlobalMenu_Pages.animal:
          Navigator({pathname: `/${GlobalMenu_Pages.animals}/${GlobalMenu_Pages.animal}`, search}, {state:{global_index:4, tab: 2, params:{...navArgs}}})
        break
        default: Navigator({pathname: `/${GlobalMenu_Pages.animals}`, search}, {state:{global_index:4, tab:0, params:{...navArgs}}})
      }
    break
    case GlobalMenu_Pages.reports:
      switch (navigation_tab) {
        case GlobalMenu_Pages.report:
          Navigator({pathname:`/${GlobalMenu_Pages.reports}/${GlobalMenu_Pages.report}`, search}, {state:{global_index:5, tab:1, params:{...navArgs}}})
        break
        case GlobalMenu_Pages.archive:
          Navigator({pathname: `/${GlobalMenu_Pages.reports}/${GlobalMenu_Pages.archive}`, search}, {state:{global_index:5, tab:2}})
        break
        default: Navigator({pathname: `/${GlobalMenu_Pages.reports}`, search}, {state:{global_index:5, tab:0}})
      }
    break
    case GlobalMenu_Pages.logbook:
      Navigator({pathname: `/${GlobalMenu_Pages.logbook}`, search}, {state:{global_index:6, tab: 0}})
    break
    case GlobalMenu_Pages.globalSettings:
      switch (navigation_tab) {
        case GlobalMenu_Pages.devices:
          Navigator({pathname: `/${GlobalMenu_Pages.globalSettings}/${GlobalMenu_Pages.devices}`, search}, {state:{global_index:7, tab:1}})
        break
        default: Navigator({pathname: `/${GlobalMenu_Pages.globalSettings}`, search}, {state:{global_index:7, tab:0}})
      }
    break
    default:
      console.log("Error page not found (404)???, [GlobalMenu]")
  }
}